import './Events.scss';

const pastEvents = [
  <li>
      May '22: <a
    className="red-link boldo" href="https://files.peakd.com/file/peakd-hive/cryptoshots.nft/23vhWN3dWcoNBsrbJFum8RLbhxzgNuCrqfvtN4ZM5aD5fed1zq1JnxomMHan3wWH6xT7x.png" target="_blank" rel="noreferrer"
    >
      Force Field
    </a> launch
  </li>,
  <li>
      Aug '22: <a
        href="https://peakd.com/hive-190697/@cryptoshots.nft/crypto-shots-full-launch-on-hive-on-august-21st"
        className="red-link boldo" target="_blank" rel="noreferrer"
      >
          <span className="boldo">Starter packs</span>
      </a> launch, <a
      id="doom-he-link"
      className="red-link boldo" href="https://peakd.com/hive-167922/@cryptoshots.nft/we-are-live" target="_blank" rel="noreferrer"
    >
      <span className="boldo">DOOM</span>
    </a> token launch
  </li>,
  <li>
    Sep '22: <a href="https://www.youtube.com/watch?v=2ZHszdLIvbc" className="red-link boldo" target="_blank" rel="noreferrer">on stage</a> at Hive Fest '22
  </li>,
  <li >
    Oct '22: Hive-Engine and <a href="https://peakd.com/hive-140217/@keys-defender/hive-and-hive-engine-witness-nodes-up-and-running-for-cryptoshotsnft" className="red-link boldo" target="_blank" rel="noreferrer">Hive witness</a> launch
  </li>,
  <li >
    Jan '23: <a href="https://peakd.com/hive-190697/@cryptoshots.nft/wen-2nd-and-3rd-level-on-january-1st" className="red-link boldo" target="_blank" rel="noreferrer">2nd and 3rd level packs</a> launch
  </li>,
  <li>
    Feb '23: <a
      href="https://peakd.com/hive-167922/@cryptoshots.nft/crypto-shots-new-diesel-pool-available-for-doom"
      className="red-link boldo" target="_blank" rel="noreferrer"
    >
        <span className="boldo">Liquidity Pool</span>
    </a> launch, <a
      href="https://peakd.com/hive-190697/@cryptoshots.nft/chatgpt-public-discord-bot--connected-to-hive-and-wax--live-in-beta"
      className="red-link boldo" target="_blank" rel="noreferrer"
    >ChatGPT Tipping bot</a> launch
  </li>,
    <li>
    May '23: <a
      href="https://peakd.com/hive-190697/@cryptoshots.nft/land-sale-on-may-29th-map-parts"
      className="red-link boldo" target="_blank" rel="noreferrer"
    >Map Parts</a> Land Sale, <a
      href="https://peakd.com/@cryptoshots.nft/the-first--play-and-earn--esports-on-the-hive-blockchain-is-here"
      className="red-link boldo" target="_blank" rel="noreferrer"
    >
        <span className="boldo">PVP Alpha Launch 🔥</span>
    </a>
  </li>,
  <li >
    Jun '23: DOOM and HIVE as  <a href="https://peakd.com/@cryptoshots.nft/the-first--play-and-earn--esports-on-the-hive-blockchain-is-here" className="red-link boldo" target="_blank" rel="noreferrer">
      gaming rewards in PVP
    </a>
  </li>,
];


const nextEvents = [
  <li>
    <p style={{ marginBottom: '0px', color: 'black' }}>[tbd]</p>
    LAND SALE: &nbsp;<i><a
        href="https://www.crypto-shots.com/drops/hive-lands-spaceships-map-parts"
        className="red-link boldo" target="_blank" rel="noreferrer"
      >SPACESHIP PARTS</a></i> &nbsp; <sub>#passiveincome</sub>
  </li>,
  <li style={{ color: 'black', marginTop: '15px' }}>
    <span style={{ marginTop: '-20px', color: 'black' }}>[tbd]</span>
    <br/><p>PVP Beta with <i><a
        href="https://peakd.com/@cryptoshots.nft"
        className="red-link boldo" target="_blank" rel="noreferrer"
      >NFTs integration</a></i> & new skins!</p>
  </li>
];


export const Events = () => {
  return (
    <div className="col-4 pl-4" id="events">
      {/* PAST EVENTS */}
      <div id="new-listings" className="floating-pane" style={{ color: 'black' }}>
        <h1 className="landing-title">Past Events:</h1>
        <ul>
          {pastEvents}
        </ul>
      </div>
      
      {/* COMING NEXT */}
      <div id="next-events" className="floating-pane" style={{ color: 'black' }}>
        <h1 className="landing-title">Coming Next:</h1>
        <ul>
          {nextEvents}
        </ul>
      </div>
    </div>
  );
};
